import { render, staticRenderFns } from "./SchoolClassList.vue?vue&type=template&id=b248ebdc"
import script from "./SchoolClassList.vue?vue&type=script&lang=js"
export * from "./SchoolClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports